import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import {useQuery} from '@apollo/client';
import {isEmpty as _isEmpty} from 'lodash';

import {CircularProgress, Backdrop} from '@ui';
import {GetEmailAlertPreviewData} from '@graphql/eventContent/query';
import {GetEventGroupNotificationPreview} from '@graphql/events/query';
import EmailAlertPreviewModal from '@modules/eventContentAlert/components/EmailAlertPreviewModal';
import {
    sendEmailAlertNotification,
    sendEmailGroupNotification,
    renderEmailPreviewButtons,
} from '@modules/eventContentAlert/utils/helpers';
import {showErrorModal} from '@utils/modal';

const EmailPreview = (props) => {
    const [dataForPreview, setDataForPreview] = useState(null);
    const [sending, setSending] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const isLiveControlPage = window.location.pathname.includes('live-control');
    const isSendAlertForm = 'sendAlert' === props.form;
    const query = isSendAlertForm ? GetEmailAlertPreviewData : GetEventGroupNotificationPreview;

    const {data, loading, error, refetch} = useQuery(query, {
        fetchPolicy: 'network-only',
        variables: props.submittedData,
    });

    if (!_isEmpty(error)) {
        setIsFetching(false);
        showErrorModal({
            header: 'Error',
            text: 'There was an error while fetching the data.',
        });
    }

    useEffect(() => {
        if (data) {
            setDataForPreview(JSON.parse(
                isSendAlertForm ?
                    data?.eventContentAlertPreview :
                    data?.eventGroupNotificationPreview
            ));
            setIsFetching(false);
        }
    }, [data]);

    useEffect(() => {
        if (!_isEmpty(props.submittedData)) {
            setIsFetching(true);

            refetch()
                .then(() => {
                    setIsFetching(false);
                })
                .catch(() => {
                    setIsFetching(false);
                    showErrorModal({
                        header: 'Error',
                        text: 'There was an error while fetching the data.',
                    });
                });
        }
    }, [props.submittedData, refetch]);

    const emailContent = {
        ...dataForPreview,
        body: dataForPreview?.body?.replace('<table>', '<table class="ui celled striped compact table">'),
    };
    const sanitizedContent = DOMPurify.sanitize(emailContent.body);
    const sendEmail = () => {
        if (!sending) {
            isSendAlertForm ?
                sendEmailAlertNotification(props.submittedData, isLiveControlPage) :
                sendEmailGroupNotification(props.submittedData);
            setSending(true);
        }
    };

    const handleBackButtonClick = (e) => {
        props.stepsMethods.showPreviousStep(e);
    };


    return (
        <>
            {loading || isFetching || !dataForPreview ? (
                <Backdrop open inverted>
                    <CircularProgress size='small'/>
                </Backdrop>
            ) : (
                <EmailAlertPreviewModal
                    dataForPreview={dataForPreview}
                    submittedData={props.submittedData}
                    sanitizedContent={sanitizedContent}
                    handleBackButtonClick={handleBackButtonClick}
                    sending={sending}
                    sendEmail={sendEmail}
                />
            )}
            <div className='AlertPreviewFooter'>
                {renderEmailPreviewButtons({handleBackButtonClick, sending, sendEmail})}
            </div>
        </>
    );
};

EmailPreview.propTypes = {
    submittedData: PropTypes.object,
    stepsMethods: PropTypes.object,
    form: PropTypes.string,
};

export default EmailPreview;
